/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isZeroValueString as n}from"../../utils/is-zero-value-string.js";function o(o){return"number"==typeof o?0===o:null!==o?"none"===o||"0"===o||n(o):void 0}export{o as isNone};
//# sourceMappingURL=is-none.js.map
